import { RESET_TERM_DATA, LOAD_TERM_DATA, LOAD_TERM_DATA_SUCCESS, LOAD_TERM_DATA_ERROR, SET_ERROR_CLOSE,
    ADD_DATA_ERROR,
    LOAD_SUBTERM_DATA,
    ADD_TERM_SUBTERM_DATA,
    SET_SELECTED_SUBTERM,
    SET_SELECTED_TERM,
    RESET_SELECTED_TERM,
    RESET_SELECTED_SUBTERM,
    LOAD_SUBTERM_DATA_SUCCESS,
    RESET_SUBTERM_DATA
}from './types'

const initialState = {
    terms: [],
    subTerms: [],
    type: '',
    errorMsg: '',
    selected: {
        term: {},
        subterm: {}
    },
    loading:{
        loadTerms: false,
        loadSubTerms: false
    }
}

const termsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case LOAD_TERM_DATA_SUCCESS:
            return {
                ...state,
                terms: payload,
                loading: {
                    ...state.loading,
                    loadTerms: false
                }
            };
        
        case LOAD_TERM_DATA:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadTerms: true
                }
            }
        case LOAD_SUBTERM_DATA:
            return {
                ...state,
                loading: {
                    ...state.loading,
                    loadSubTerms: true
                }
            }
        case LOAD_SUBTERM_DATA_SUCCESS:
            return {
                ...state,
                subTerms: payload,
                loading: {
                    ...state.loading,
                    loadSubTerms: false
                }
            }
        
        case SET_ERROR_CLOSE:
            return {
                ...state,
                errorMsg: '',
                loading: {
                    ...state.loading,
                    loadTerms: false,
                    loadSubTerms: false
                }
        }
        
        case ADD_DATA_ERROR:
            return {
                ...state,
                errorMsg: payload
            }
        
        case ADD_TERM_SUBTERM_DATA:
            return {
                ...state,
                type: payload
            }
        case RESET_TERM_DATA:
            return {
                ...state,
                terms: [],
                subTerms: [],
                selected: {
                    term: {},
                    subterm: {}
                },
                loading:{
                    loadTerms: false,
                    loadSubTerms: false
                }
            }
        case SET_SELECTED_TERM:
            return{
                ...state,
                selected: {
                    ...state.selected,
                    term: payload
                }
            }
        case SET_SELECTED_SUBTERM:
            return{
                ...state,
                selected: {
                    ...state.selected,
                    subterm: payload
                }
            }
        case RESET_SELECTED_TERM:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    term: {}
                }
            }
        case RESET_SELECTED_SUBTERM:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    subterm: {}
                }
            }
        case RESET_SUBTERM_DATA:
            return {
                ...state,
                subTerms: []
            }
        default:
            return state;
    }
}
export default termsReducer;